import { Component, OnInit } from "@angular/core";

@Component({
    selector: "new-casing-plan-background-info",
    templateUrl: "./new-casing-plan-background-info.component.html",
    styleUrls: ["./new-casing-plan-background-info.component.scss"],
    standalone: false
})
export class NewCasingPlanBackgroundInfoComponent implements OnInit {

    
    selectMode: boolean = true;
    viewingContent: string = "";

    constructor() { }

    ngOnInit() {
    }

    backToIndex(): void {
        this.selectMode = true;
        this.viewingContent = "";
    }

    viewContent(content: string): void {
        this.selectMode = false;
        this.viewingContent = content;
    }
}
